import { render, staticRenderFns } from "./BottomInfo.vue?vue&type=template&id=3389c4ab&"
import script from "./BottomInfo.vue?vue&type=script&lang=js&"
export * from "./BottomInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports